export default __webpack_public_path__ + "static/media/kryesoreFullKompresuar.7f0c9fd8.jpg";